// Central backend API configuration.
//
// The frontend (hosted on USC's servers at https://alumni.usc.edu.tt) talks to
// the Python backend hosted on Render. To point the frontend at a different
// backend — e.g. when the backend moves to another Render account — set
// VITE_API_BASE_URL at build time, OR just change the default below and rebuild.
//
// VITE_API_BASE_URL must include the /api suffix, e.g.
//   https://your-backend.onrender.com/api
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://usc-alumni-backend-pqnr.onrender.com/api';

// The same host WITHOUT the trailing /api, for the few calls that need the origin.
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');
